export default __webpack_public_path__ + "static/media/010_background.e87dbe0d.gif";